import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';

const getServerSidePolicyType = (policyType: PolicyTypeEnum | null): string => {
  let type: string;
  switch (policyType) {
    case PolicyTypeEnum.shortForm:
      type = 'short_form_loan';
      break;
    case PolicyTypeEnum.longForm:
      type = 'long_form_loan';
      break;
    default:
      type = 'owner';
      break;
  }
  return type;
};

export default getServerSidePolicyType;
